angular.module('billing').controller('PaymentFromNewCardCtrl',
                ['$scope','$state', '$stateParams', '$location', 'BillingRepository', 'PatientPortalStorageRepository', 'BillingService', '$sce', 'TransitionManager', 'toaster', 'aprgettext',
        function ($scope,  $state,   $stateParams,   $location,   BillingRepository,   PatientPortalStorageRepository,   BillingService,   $sce,   TransitionManager,   toaster,   gettext) {

            'use strict';

            var loginUserId = PatientPortalStorageRepository.getLoginUser().id;
            $scope.loadingBillingAccount = true;
            $scope.model = {
                HasCardOnFile: false,
                PersonBalanceAll: $stateParams.amount,
                FinancialCenterGuid: $stateParams.financialCenterUid,
                MerchantId: $stateParams.merchantId,
                OneTimePaymentUrl: '',
                RedirectUrl: '',
                ConsentAnnual: {
                    Mask: '',
                    CardType: '',
                    ExpDate: '',
                    ConsentId: '',
                    RemainingInConsent: '',
                    PerChargeLimit: ''
                }
            };

            $scope.statementsOnly = getState();

            function getState()
            {
                return  $state.current.alternativeLoginRoute;
            }
            function loadPage() {
                loginUserId = PatientPortalStorageRepository.getLoginUser().id;
                loadBillingAccount();
            }

            function loadBillingAccount() {
                $scope.loadingBillingAccount = true;
                $scope.removeHttpError();
                var requestDto = {
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: ''
                };

                BillingService
                    .getBillingAccount(requestDto)
                    .then(function (billingAccountDto) {
                        if (billingAccountDto.ConsentAnnual) {
                            $scope.model.ConsentAnnual = billingAccountDto.ConsentAnnual;
                            $scope.model.HasCardOnFile = true;
                        }
                        loadOneTimePayment();
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loadingBillingAccount = false;
                    });
            }

            function loadOneTimePayment() {
                $scope.loadingUrl = true;

                var absPath = $location.absUrl(),
                    partial = $location.path(),
                    newPartial = '/transactionComplete/';
                var absPathSplit = absPath.split('?')[0];
                var redirectUrl = absPathSplit.replace(partial, newPartial);
                var oneTimePaymentRequestDto = {
                    Amount: $scope.model.PersonBalanceAll,
                    RedirectUrl: redirectUrl,
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString(),
                    FinancialCenterGuid: $scope.model.FinancialCenterGuid,
                    MerchantId: $scope.model.MerchantId
                };

                BillingRepository
                    .getOneTimePaymentUrl(oneTimePaymentRequestDto)
                    .then(function (url) {
                        if (url) {
                            $scope.model.OneTimePaymentUrl = $sce.trustAsResourceUrl(url);
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loadingUrl = false;
                    });
            }

            function redirectUrlPostBack(url) {

                var applyPaymentRequestDto = {
                    PaymentResponseString: url,
                    LoginUserPatientId: loginUserId,
                    ApplicationSubmittingPayment: '1', //enum SourceOfPayments.PatientPortal
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString(),
                    FinancialCenterGuid: $scope.model.FinancialCenterGuid
                };
                BillingRepository
                    .postApplyPayment(applyPaymentRequestDto)
                    .then(function (data) {
                        $scope.statementsOnly = getState();
                        if (data.IsCanceled) {
                            toaster.pop('warn', '', gettext('Payment has been canceled.'));
                            if($scope.statementsOnly)
                            {
                                TransitionManager.transition({appRoute: 'paymentStatementsOnly'});
                            }
                            else{
                            TransitionManager.transition({appRoute: 'billing'});
                            }
                        } else {
                            if($scope.statementsOnly) {
                                TransitionManager.transition({appRoute: 'paymentSummaryStatementsOnly', opts: {txId: data.TxId}});
                            }
                            else{
                                TransitionManager.transition({appRoute: 'paymentSummary', opts: {txId: data.TxId}});
                            }
                        }

                    })
                    .catch(function (response) {
                        toaster.pop('error', '', gettext('An error occurred while submitting the payment'));
                        $scope.addHttpError(response);
                    });
            }

            $scope.redirectUrlPostBack = redirectUrlPostBack;
            loadPage();
        }
    ]
);